import type { RepeatedSchedule } from "@smartsuite/automation-engine-api";

import { makeAutoObservable } from "mobx";

export class ScheduleStore {
  schedule?: RepeatedSchedule;

  constructor() {
    makeAutoObservable(this);
  }

  setSchedule(schedule?: RepeatedSchedule): void {
    this.schedule = schedule;
  }
}
